import { Toaster as Sonner, type ToasterProps } from "sonner";

// Carbon-glass toasts tuned to the Transmission palette. Success → lime,
// error → coral, info → neutral. Mounted once at the app root.
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="dark"
      position="bottom-right"
      offset={16}
      toastOptions={{
        classNames: {
          toast:
            "group !rounded-xl !border !border-white/10 !bg-popover/95 !text-foreground !shadow-2xl !shadow-black/60 !backdrop-blur-xl",
          title: "!text-sm !font-medium",
          description: "!text-xs !text-muted-foreground",
          actionButton: "!bg-primary !text-primary-foreground",
          cancelButton: "!bg-secondary !text-secondary-foreground",
          success: "[&_[data-icon]]:!text-primary",
          error: "[&_[data-icon]]:!text-destructive",
          icon: "!size-4",
        },
      }}
      style={
        {
          "--normal-bg": "hsl(var(--popover))",
          "--normal-text": "hsl(var(--foreground))",
          "--normal-border": "hsl(var(--border))",
        } as React.CSSProperties
      }
      {...props}
    />
  );
}
